var React = require('react');

function DirectionHorizontalArrow (props) {
    return React.createElement("svg",props,[React.createElement("path",{"d":"M144.1 33.7H3.7C1.6 33.7 0 32 0 30s1.6-3.7 3.7-3.7h140.5c2 0 3.7 1.6 3.7 3.7s-1.7 3.7-3.8 3.7z","key":0}),React.createElement("path",{"d":"M27.1 60c-1 0-2-.4-2.7-1.2L.9 32.4C-.3 31-.3 28.9.9 27.5L24.3 1.2C25.6-.3 28-.5 29.5.9c1.5 1.3 1.6 3.7.3 5.2L8.6 30l21.3 23.9c1.3 1.5 1.2 3.8-.3 5.2-.8.6-1.7.9-2.5.9zm93.6 0c-.9 0-1.7-.3-2.4-.9-1.5-1.3-1.7-3.7-.3-5.2L139.2 30 118 6.1c-1.3-1.5-1.2-3.8.3-5.2 1.5-1.3 3.8-1.2 5.2.3l23.4 26.3c1.2 1.4 1.2 3.5 0 4.9l-23.4 26.3c-.8.9-1.8 1.3-2.8 1.3z","key":1})]);
}

DirectionHorizontalArrow.defaultProps = {"baseProfile":"tiny","viewBox":"0 0 147.8 60","overflow":"visible"};

module.exports = DirectionHorizontalArrow;

DirectionHorizontalArrow.default = DirectionHorizontalArrow;
